import { useState } from "react";
import { PageHeader } from "../components/Layout";
import WheelView from "../components/WheelView";
import { Button } from "../components/ui/button";

export default function CustomWheels() {
  const [tab, setTab] = useState("custom1");
  return (
    <div className="p-5 md:p-8 max-w-7xl mx-auto">
      <PageHeader title="Ruote Personalizzate" subtitle="Due ruote completamente configurabili. Modifica gli elementi da Gestione contenuti." accent="amber" />
      <div className="flex gap-2 mb-6">
        <Button
          data-testid="tab-custom1"
          onClick={() => setTab("custom1")}
          className={tab === "custom1" ? "bg-violet-600 hover:bg-violet-500 text-white" : "bg-[#11141d] border border-[#334155] text-slate-300 hover:bg-[#181d2a]"}
        >
          Ruota Custom 1
        </Button>
        <Button
          data-testid="tab-custom2"
          onClick={() => setTab("custom2")}
          className={tab === "custom2" ? "bg-emerald-600 hover:bg-emerald-500 text-white" : "bg-[#11141d] border border-[#334155] text-slate-300 hover:bg-[#181d2a]"}
        >
          Ruota Custom 2
        </Button>
      </div>
      {tab === "custom1" ? (
        <WheelView slug="custom1" accentType="custom" key="c1" />
      ) : (
        <WheelView slug="custom2" accentType="custom" key="c2" />
      )}
    </div>
  );
}
